export enum Environment {
  Test = 'test',
  Preprod = 'preprod',
  Prod = 'prod'
}



// WEBPACK FOOTER //
// ./src/shared/Enums/Environment.ts